import React from "react";
import styles from "./PreviewHistory.module.scss";
import { PreviewHistoryList } from "./PreviewHistoryList";
interface PreHistoryProps {
  addNewPreview: () => void;
  selectPreview: (previewData: PreviewApp.UISaasValueType) => void;
}

export function PreviewHistory(props: PreHistoryProps) {
  function createNewPreview() {
    props.addNewPreview();
  }

  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <div className={styles.title}>Publish as</div>
        <div className={styles.subtitle}>Turn your thoughts into reality with just a click</div>
      </div>

      <div className={styles.history}>
        <PreviewHistoryList selectPreview={val => props.selectPreview(val)} createNewPreview={createNewPreview} />
      </div>
    </div>
  );
}
